import { ImagePaths } from '../../lib/imageUrls.js';

export const essentialEightFundamentals = {

    id: 7,
    slug: 'essential-eight-fundamentals',
    ogImage: '/og/courses/essential-eight-fundamentals.jpg',
    courseCode: 'E8-FND-001',
    featured: true,
    title: 'Essential Eight Fundamentals',
    subtitle: 'Master Australia\'s essential cybersecurity strategies',
    valueProposition: 'Achieve ACSC compliance and significantly reduce your organisation\'s cyber risk through Australia\'s most effective mitigation strategies.',
    duration: '8 hours',
    students: 'New',
    level: 'Foundational',
    image: ImagePaths.COURSE_2,
    shortDescription: 'E8-FND-001 — Essential Eight implementation covering all eight ACSC mitigation strategies and maturity levels for Australian IT managers and contractors.',
    price: {
      aud: 499,
      currency: 'AUD',
      earlyBird: 399
    },
    stripeConfig: {
    priceId: 'price_1SdKSXKu1nyc322UCRbnufyH',
    productId: 'prod_TaVTWMQYt9T9xt'
  },
    
    snapshot: {
      whoItsFor: [
        'Australian government contractors and suppliers',
        'IT managers implementing ACSC compliance',
        'Security officers responsible for cyber resilience',
        'Small to medium business owners and managers'
      ],
      accreditation: 'Australian Cyber Security Centre (ACSC) Essential Eight'
    },
    
    logistics: {
      classSize: 'Self-paced online with live Q&A sessions',
      requirements: [
        'Laptop or desktop computer',
        'Administrative access to test environment (optional)',
        'Basic understanding of IT systems and networks'
      ]
    },
    
    overview: 'Learn to implement the Australian Cyber Security Centre\'s Essential Eight mitigation strategies. This focused course provides practical, actionable guidance specifically for Australian organisations to meet compliance requirements and significantly reduce cyber risk. Perfect for government contractors, IT managers, and business leaders responsible for cybersecurity.',
    
    outcomes: [
      'Implement all eight ACSC mitigation strategies to the appropriate maturity level',
      'Assess your organisation\'s current Essential Eight maturity and identify gaps',
      'Develop a practical roadmap for achieving and maintaining compliance',
      'Apply application control and patch management effectively across your environment',
      'Configure multi-factor authentication and restrict administrative privileges',
      'Establish robust backup and recovery procedures resistant to ransomware',
      'Meet Australian government contractor requirements and pass security assessments',
      'Communicate Essential Eight requirements and benefits to executive stakeholders'
    ],
    
    audience: [
      'Australian government contractors',
      'IT managers and security officers',
      'Compliance and risk professionals',
      'Small business owners and managers',
      'Anyone needing Essential Eight compliance'
    ],
    
    prerequisites: [
      'Basic IT knowledge',
      'Understanding of business operations',
      'No specific technical experience required'
    ],
    
    modules: [
      {
        title: 'Essential Eight Overview',
        duration: '1 hour',
        topics: [
          'History and purpose of Essential Eight',
          'Maturity levels explained',
          'Compliance requirements',
          'Implementation priorities'
        ]
      },
      {
        title: 'Application Control & Patching',
        duration: '2 hours',
        topics: [
          'Application control strategies',
          'Patch management programs',
          'Operating system patching',
          'Application patching processes'
        ]
      },
      {
        title: 'User Restrictions & Authentication',
        duration: '2 hours',
        topics: [
          'Restricting administrative privileges',
          'Multi-factor authentication (MFA)',
          'User application hardening',
          'Password management'
        ]
      },
      {
        title: 'Backups & Recovery',
        duration: '1.5 hours',
        topics: [
          'Daily backup strategies',
          'Backup testing procedures',
          'Disaster recovery planning',
          'Ransomware resilience'
        ]
      },
      {
        title: 'Implementation Planning',
        duration: '1.5 hours',
        topics: [
          'Maturity assessment',
          'Roadmap development',
          'Resource planning',
          'Ongoing compliance'
        ]
      }
    ],
    
    format: {
      type: 'Compact self-paced course',
      includes: [
        '8 hours of focused training',
        'Implementation templates and checklists',
        'Maturity assessment tools',
        'Policy templates',
        'Certificate of completion',
        'Lifetime access to materials'
      ]
    },
    
    nextIntake: {
      date: 'Register your interest — we will confirm the next cohort',
      details: 'Immediate access - complete in 1-2 days'
    },
    
    faqs: [
      {
        question: 'Is this course required for Australian government contractors?',
        answer: "While the course itself isn't mandatory, implementing the Essential Eight is required for organisations contracting with the Australian government. This course provides the knowledge and tools to meet those requirements efficiently."
      },
      {
        question: 'What maturity level does this course cover?',
        answer: "We cover all three maturity levels (Level 1, 2, and 3) as defined by the ACSC. You'll learn the requirements for each level and how to prioritise implementation based on your organisation's risk profile and compliance obligations."
      },
      {
        question: 'Will I receive implementation templates and tools?',
        answer: "Yes, you'll receive comprehensive implementation checklists, policy templates, maturity assessment tools, and roadmap templates. These resources are designed to accelerate your Essential Eight implementation."
      },
      {
        question: 'How quickly can I complete the course?',
        answer: 'This focused 8-hour course can be completed in 1-2 days at your own pace. You\'ll have lifetime access to all materials and updates as the ACSC guidance evolves.'
      },
      {
        question: 'Is this suitable for small businesses with limited IT resources?',
        answer: 'Absolutely. The course includes practical guidance specifically for resource-constrained organisations, including cost-effective implementation strategies and prioritisation frameworks suitable for businesses of all sizes.'
      },
      {
        question: 'What if the Essential Eight guidance is updated by ACSC?',
        answer: 'We regularly update course content to reflect the latest ACSC guidance. As an enrolled participant, you\'ll receive free access to all updates and be notified when significant changes occur.'
      },
      {
        question: 'Can I claim this course for professional development?',
        answer: 'Yes, this course qualifies for professional development hours with most Australian professional bodies including ACS, ISACA, and (ISC)². Your Certificate of Completion includes the required details for CPD claims.'
      },
      {
        question: 'Do you offer group rates for teams?',
        answer: 'Yes, we offer discounted rates for organisations enrolling multiple staff members. Contact us for a quote tailored to your team size and requirements.'
      }
    ]
};
